export default "__VITE_ASSET__DK$uu0Y5__"